import { Banner, Text } from '@shopify/polaris';

const GeneratingBarcodesNotice = ({ payload, notice }) => {
  if(notice.variant_symbols) {
    return(
      <Banner>
        <Text>Generating barcodes</Text>
        <Text>Generating {notice.variant_symbols.length} barcode images.</Text>
      </Banner>
    )
  }

  return(
    <>
    </>
  )
}

export default GeneratingBarcodesNotice;
